import {Box, Grid, Typography, useTheme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import React, {useEffect, useState} from "react";
import {useI18N, useLocation} from "../../../common/common";
import {
    PROFILE_ACCOUNT_SETTINGS_PERSONAL_DETAILS,
    PROFILE_ACCOUNT_SETTINGS_PRIVACY_AND_NOTIFICATIONS,
    PROFILE_ACCOUNT_SETTINGS_CHANGE_PASSWORD,
    PROFILE_ACCOUNT_SETTINGS_MY_BANK_ACCOUNTS,
} from "../../../common/routes";
import CardButton from "../../widget/button/CardButton";
import StreamlineIcon from "../../widget/streamline-icon/StreamlineIcon";
import CenterContainer from "../CenterContainer";
import SingleMan from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/users/geomertic-close-up-single-user-man/single-man.svg";
import PasswordLock from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/password/password-lock-1.svg";
import Cog from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/settings/cog.svg";
import SavingBank from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/money-payments-finance/finance-savings/saving-bank.svg";
import {useKeycloakFunctions} from "../../../hooks";

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    accountSettingsCard: {
        display: "flex",
        padding: theme.spacing(3),
        justifyContent: "flex-start",
        [theme.breakpoints.up("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start"
        }
    },
    streamLineIcon: {
        [theme.breakpoints.down("sm")]: {
            marginRight: theme.spacing(2),
            width: theme.spacing(3),
            height: theme.spacing(3),
        },
        [theme.breakpoints.up("sm")]: {
            marginBottom: theme.spacing(2),
            width: theme.spacing(6),
            height: theme.spacing(6),
        },
    },
}));

export const AccountSettingsView = () => {
    const theme = useTheme();
    const classes = useStyles();
    const {i18n} = useI18N();
    const {navigate} = useLocation();
    const {authenticated, isProspect, isTrialMember} = useKeycloakFunctions();
    const [options, setOptions] = useState([
        {icon: <SingleMan />, label: i18n("view.profile.account_settings.personal_details"), route: PROFILE_ACCOUNT_SETTINGS_PERSONAL_DETAILS},
        {icon: <PasswordLock />, label: i18n("view.profile.account_settings.change_password"), route: PROFILE_ACCOUNT_SETTINGS_CHANGE_PASSWORD},
        {icon: <Cog />, label: i18n("view.profile.account_settings.privacy_notifications"), route: PROFILE_ACCOUNT_SETTINGS_PRIVACY_AND_NOTIFICATIONS},
    ]);

    useEffect(() => {
        if (authenticated && !isProspect() && !isTrialMember()) {
            setOptions(options => [...options, {icon: <SavingBank />, label: i18n("view.profile.account_settings.bank_accounts.my_bank_accounts"), route: PROFILE_ACCOUNT_SETTINGS_MY_BANK_ACCOUNTS}]);
        }
    }, [authenticated]);

    return (
        <CenterContainer
            className={classes.container}
            maxWidth={theme.breakpoints.width("md")}
        >
            {options &&
                <>
                    <Box
                        my={3}
                    >
                        <Typography
                            variant={"h1"}
                        >
                            {i18n("view.profile.account_settings.title")}
                        </Typography>
                    </Box>
                    <Box>
                        <Grid
                            container
                            spacing={2}
                        >
                            {options.map((option, index) => {
                                return (
                                    <Grid
                                        key={index}
                                        item
                                        xs={12}
                                        sm={6}
                                    >
                                        <CardButton
                                            className={classes.accountSettingsCard}
                                            onClick={() => {navigate(option?.route);}}
                                        >
                                            {option?.icon &&
                                                <StreamlineIcon className={classes.streamLineIcon}>
                                                    {option.icon}
                                                </StreamlineIcon>
                                            }

                                            {option?.label &&
                                                <Typography
                                                    variant={"h6"}
                                                >
                                                    {option.label}
                                                </Typography>
                                            }
                                        </CardButton>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                </>
            }
        </CenterContainer>
    );
};

export default AccountSettingsView;
